import React from 'react';
import whatsAppIcon from '../assets/tech-whatsapp.png';

function WhatsAppContact({ position = 'right', offset = '1px' }) {
  const handleWhatsAppPress = () => {
    const emoji = String.fromCodePoint(0x1F44B); // "👋"
    const rawMessage = `Olá! ${emoji} Quero solicitar um orçamento!`;
    const encodedMessage = encodeURIComponent(rawMessage);
    window.open(`https://wa.me/5511965442886?text=${encodedMessage}`, '_blank');
  };

  const containerStyles = {
    position: 'fixed',
    bottom: '20px', // Mantém a altura configurável
    zIndex: '1000',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Centraliza o texto e o botão
    gap: '10px', // Espaçamento entre o botão e o texto
    [position]: offset, // Define se o botão estará mais à direita ou à esquerda
  };

  return (
    <div style={containerStyles}>
      {/* Botão do WhatsApp */}
      <div
        style={{
          backgroundColor: '#25D366',
          borderRadius: '50%',
          width: '70px',
          height: '70px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
        onClick={handleWhatsAppPress}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.5)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
        }}
      >
        <img
          src={whatsAppIcon}
          alt="Contact us on WhatsApp"
          style={{
            width: '40px',
            height: '40px',
          }}
        />
      </div>
      {/* Texto em formato de chat */}
      <div
        style={{
          backgroundColor: '#ffffff',
          color: '#333',
          fontSize: '14px',
          fontWeight: 'bold',
          textAlign: 'center',
          borderRadius: '15px',
          padding: '8px 15px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          maxWidth: '150px',
          position: 'relative',
        }}
      >
        <span>Leal Transporte</span>
        {/* Triângulo do balão de chat */}
        <div
          style={{
            position: 'absolute',
            bottom: '-10px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '0',
            height: '0',
            borderLeft: '10px solid transparent',
            borderRight: '10px solid transparent',
            borderTop: '10px solid #ffffff',
          }}
        ></div>
      </div>
    </div>
  );
}

export default WhatsAppContact;
